import React from 'react';
import { WebsiteDesignProps } from './types';
import { Scissors, Ruler, Shirt } from 'lucide-react';
import { Button } from "@/components/ui/button";

const FashionDesign: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Maison de Couture";

    return (
        <div className="bg-white min-h-screen font-sans text-black">
            <nav className="border-b border-black py-6 px-8 flex justify-between items-center">
                <div className="text-xl font-bold uppercase tracking-[0.3em]">
                    {schoolName}
                </div>
                <div className="hidden md:flex gap-8 text-xs uppercase tracking-[0.2em] font-medium">
                    <a href="#" className="hover:line-through">Collections</a>
                    <a href="#" className="hover:line-through">Atelier</a>
                    <a href="#" className="hover:line-through">Journal</a>
                </div>
                <Button variant="ghost" className="text-xs uppercase tracking-[0.2em] hover:bg-black hover:text-white rounded-none">
                    Contact
                </Button>
            </nav>

            <header className="grid grid-cols-1 md:grid-cols-2 min-h-[90vh]">
                <div className="flex flex-col justify-center p-12 md:p-20">
                    <span className="text-xs uppercase tracking-[0.3em] text-gray-400 mb-6">
                        Paris • Milan • New York
                    </span>
                    <h1 className="text-5xl md:text-7xl font-light leading-none mb-8">
                        The Future <br/> of <em className="font-serif italic">Fashion</em>
                    </h1>
                    <p className="text-lg text-gray-600 mb-10 max-w-md leading-relaxed">
                        Where tradition meets innovation. Train with master couturiers and define the next era of style.
                    </p>
                    <Button className="bg-black text-white hover:bg-gray-800 w-fit uppercase tracking-[0.2em] text-xs px-10 py-6 rounded-none">
                        Enrollment 2026
                    </Button>
                </div>

                <div className="relative bg-[#f5f5f5] overflow-hidden">
                    <img 
                        src="https://images.unsplash.com/photo-1558618666-fcd25c85cd64?q=80&w=1932&auto=format&fit=crop" 
                        className="w-full h-full object-cover" 
                        alt="Fashion" 
                    />
                    <div className="absolute bottom-8 right-8 bg-white p-4 text-xs uppercase tracking-[0.2em]">
                        S/S 2026 Collection Preview
                    </div>
                </div>
            </header>

            <section className="border-t border-black">
                <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-black">
                    {[
                        { icon: Scissors, title: "Tailoring", desc: "Precision cutting and construction techniques." },
                        { icon: Ruler, title: "Pattern Making", desc: "From concept sketch to production-ready patterns." },
                        { icon: Shirt, title: "Textile Design", desc: "Fabric innovation and sustainable materials." },
                    ].map((item, i) => (
                        <div key={i} className="p-12 hover:bg-black hover:text-white transition-colors group cursor-pointer">
                            <item.icon className="mb-6 group-hover:text-white" size={28} strokeWidth={1} />
                            <h3 className="text-lg font-bold uppercase tracking-widest mb-3">{item.title}</h3>
                            <p className="text-sm text-gray-500 group-hover:text-gray-300 leading-relaxed">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default FashionDesign;
